import { getType } from 'typesafe-actions';
import { TLoanActions, loanActions } from '../actions/loan.actions';
import { accountActions } from '../constants';
import { RequestState } from '../constants/request-state';
import { LoanState } from '../types/state/LoanState';

const initialState: LoanState = {
    loans: [],
    requestState: RequestState.none,
    nextPageRequestState: RequestState.none,
    editPopupRequestState: RequestState.none,
    saveRequestState: RequestState.none,
    exportRequestState: RequestState.none,
    totalRecordNumber: 0,
    currentPageNumber: 1,
    pageSize: 50,
    issuersSearch: [],
    shouldRestoreFiltersQueryString: false,
};


export function loan(state = initialState, action: TLoanActions): LoanState {
    if (action.type === accountActions.LOGOUT) {
        return initialState;
    }

    switch (action.type) {
        case getType(loanActions.reset):
             return initialState;
        case getType(loanActions.resetLoans):
            return { ...initialState, sortingField: state.sortingField, sortDirection: state.sortDirection, issuersSearch: state.issuersSearch };
        case getType(loanActions.request):
            return { ...state, requestState: RequestState.request };
        case getType(loanActions.requestSuccess):
            return {
                ...state,
                loans: state.loans.concat(action.payload.loans),
                totalRecordNumber: action.payload.totalRecordNumber,
                requestState: RequestState.success,
                nextPageRequestState: RequestState.none,
            };
        case getType(loanActions.requestError):
            return { ...state, requestState: RequestState.failure, nextPageRequestState: RequestState.none };
        case getType(loanActions.nextPageRequest):
            return { ...state, currentPageNumber: state.currentPageNumber + 1, nextPageRequestState: RequestState.request };
        case getType(loanActions.nextPageRequestSuccess):
            return {
                ...state,
                loans: state.loans.concat(action.payload.loans),
                totalRecordNumber: action.payload.totalRecordNumber,
                nextPageRequestState: RequestState.success,
            };
        case getType(loanActions.nextPageRequestError):
            return { ...state, currentPageNumber: state.currentPageNumber - 1, nextPageRequestState: RequestState.failure };
        case getType(loanActions.deleteLoanSuccess):
            return {
                ...state,
                loans: state.loans.filter(l => l.id !== action.payload.id),
                totalRecordNumber: state.totalRecordNumber - 1,
            };
        case getType(loanActions.loanUpdated):
            return { ...state, editPopupRequestState: RequestState.request };
        case getType(loanActions.loanUpdatedSuccess):
            return {
                ...state,
                loans: action.payload.loan
                    ? state.loans.map(l => l.id === action.payload.loan!.id ? action.payload.loan! : l)
                    : state.loans,
                editPopupRequestState: RequestState.success,
            };
        case getType(loanActions.loanUpdatedError):
            return { ...state, editPopupRequestState: RequestState.failure };
        case getType(loanActions.adminLoanSave):
            return { ...state, saveRequestState: RequestState.request };
        case getType(loanActions.saveLoanSuccess):
            return {
                ...state,
                loans: state.loans.map(l => l.id === action.payload.loan.id ? action.payload.loan : l),
                saveRequestState: RequestState.success,
            };
        case getType(loanActions.saveLoanError):
            return { ...state, saveRequestState: RequestState.failure };
        case getType(loanActions.saveLoanReset):
            return { ...state, saveRequestState: RequestState.none };
        case getType(loanActions.issuerSearchChange):
            return { ...state, issuersSearch: action.payload.issuerSearch };
        case getType(loanActions.sortChange):
            return { ...state, sortingField: action.payload.sortingField, sortDirection: action.payload.sortDirection, currentPageNumber: 1 };
        case getType(loanActions.setShouldRestoreFiltersQueryString):
            return { ...state, shouldRestoreFiltersQueryString: action.payload.value };
        case getType(loanActions.exportLoans):
            return { ...state, exportRequestState: RequestState.request };
        case getType(loanActions.exportLoansSuccess):
            return { ...state, exportRequestState: RequestState.success };
        case getType(loanActions.exportLoansError):
            return { ...state, exportRequestState: RequestState.failure };
        default:
            return state;
    }
}
